import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicRemarque = () => {
  const { auth, setOngletPaiementActif, windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Fonctionnement de Wodzone', link: '/topics/about/fonctionnement'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <div className="article-container mt-8">
              <p className="help-text">
                Nous aimons connaître votre degré de satisfaction. <a target='_blank' className="link" href="#">Faites part de vos remarques</a>sur une fonctionnalité Wodzone, 
                signalez un problème, et plus encore.
              </p>
              <p className="help-text">
                Si vous avez des questions sur un sujet différent, <a target='_blank' className="link" href="/topics/about/4">trouvez de l'aide ou contactez Wodzone.</a>
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicRemarque